import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiModelDeletionFailedAction = {
	type: 'AI_MODEL_DELETION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiModelDeletionFailedAction => ({
	type: 'AI_MODEL_DELETION_FAILED',
	payload,
});
